import React, { CSSProperties, ReactNode } from 'react';

export const inputTableBorder = '1px solid rgba(224, 224, 224, 1)';

export interface InputTableColumns {
  id: string;
  label: React.ReactNode;
  tooltipText?: string;
  style?: CSSProperties;
}

export interface UpHeaderColumn {
  id: string | number;
  title?: string;
  element?: ReactNode;
  style?: CSSProperties;
}

export interface ErrorList {
  type: string;
  id: string | number;
  value?: number | boolean;
}
